module.exports = __webpack_public_path__ + "img/avatar4.d4334d9c.png";